import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-12 xl:h-16 flex justify-between items-center pr-4 md:pr-6 xl:pr-2 border-b border-ternary top-14 w-full z-10 bg-secondary xl:static" }


import CloseButton from "@/components/buttons/CloseButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  emits: ["close"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "header-content"),
    _createVNode(CloseButton, {
      onClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      class: "ml-auto"
    })
  ]))
}
}

})